import Macy from 'macy';
// https://www.kunkalabs.com/mixitup/docs/get-started/
// import mixitup from 'mixitup';
// import mixitupMultifilter from '../plugins/mixitup-multifilter.min.js';
// import mixitupMultifilter from '../../../plugins/mixitup/dist/mixitup-multifilter.js';
// mixitup.use(mixitupMultifilter);

$(document).ready(function() {

   
    if ($('.themen--wrap').length) {
        masonryGrid();
    }
    if ($('.toolbox--mix--filter').length) {
        masonryGridToolbox();
    }
    

    var initialFilter = 'all';
    var hash = window.location.hash.replace(/^#/g, '');
    if (hash) {
        initialFilter = '.' + hash;
    }

    if ($('.mixit--filter').length) {
        var mixer = mixitup(".mixit--filter", {
            animation: {
                animateResizeTargets: false,
                duration: 550,
                nudge: true,
                reverseOut: false,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            selectors: {
                control: '.mixitup-control'
            },
            load: {
                filter: initialFilter
            },
        });
    }

    if ($('.themen--mix--filter').length) {
        var mixerThemem = mixitup(".themen--mix--filter", {
            animation: {
                animateResizeTargets: false,
                duration: 550,
                nudge: true,
                reverseOut: false,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            selectors: {
                control: '.mixitup-control'
            },
            load: {
                filter: initialFilter
            },
            callbacks: { 
                onMixEnd: function(state){
                    masonryGrid(); // ******* here call masonry function
                }
            }
        });
    }


    if ($('.toolbox--mix--filter').length) {
        var mixerToolboxTopTierMix = mixitup(".toolbox--mix--filter", {
            animation: {
                animateResizeTargets: false,
                duration: 550,
                nudge: true,
                reverseOut: true,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            controls: {
                toggleLogic: 'and',
                toggleDefault: 'all'
            },
            multifilter: {
				enable: true, // enable the multifilter extension for the mixer
			},
            selectors: {
                control: '.toolbox-filter'
            },
            callbacks: { 
                onMixEnd: function(state){
                    masonryGridToolbox(); // ******* here call masonry function
                }
            }
        });

    }


    /**
     * Search Text Start
     */
    // var container = document.querySelector('[data-ref="container"]');

    var inputSearch = document.querySelector('[data-ref="input-search"]');
    var keyupTimeout;

    if(inputSearch) {
        
    inputSearch.addEventListener('keyup', function() {
        var searchValue;

        if (inputSearch.value.length < 1) {
            // If the input value is less than 3 characters, don't send
            toolboxMixFilter.hide();

            searchValue = '';

        } else {
            searchValue = inputSearch.value.toLowerCase().trim();
        }

        // Very basic throttling to prevent mixer thrashing. Only search
        // once 350ms has passed since the last keyup event

        clearTimeout(keyupTimeout);

        keyupTimeout = setTimeout(function() {
            filterByString(searchValue);
        }, 350);
    });

     /**
     * Filters the mixer using a provided search string, which is matched against
     * the contents of each target's "class" attribute. Any custom data-attribute(s)
     * could also be used.
     *
     * @param  {string} searchValue
     * @return {void}
     */

     function filterByString(searchValue) {
        if (searchValue) {
            // Use an attribute wildcard selector to check for matches

            toolboxMixFilter.filter('[data-text*="' + searchValue + '"]');
        } else {
            // If no searchValue, treat as filter('all')

            toolboxMixFilter.filter('none');
        }
    }
      /**
     * Search Text End
     */

    // $('.top-toolbox-sub-filter').hide();
    // $('.top-toolbox-filter[data-filter="all"]').on('click',function() {
    //     mixerToolboxTopTierMix.hide();
    //     toolboxMixFilter.show();
    // });
    // var allSubmenu = $('.top-toolbox-sub-filter');
    // $('.top-tier-filter').on('click',function() {
    //     toolboxMixFilter.hide();
    //     allSubmenu.hide();
    // });
    // $('.top-toolbox-filter[data-filter]').on('click',function() {
    //     $('.top-toolbox-sub-filter').show();
    // });
   
    }


   

});

function masonryGrid(){
    var macyInstance = Macy({
        // See below for all available options.
        container: '.themen--wrap',
        columns: 1,
        trueOrder: true,
        margin: 20,
        mobileFirst: true,
        breakAt: {
          768: {
            columns: 2
          },
          1024: {
            columns: 3
          }
        }
      });
}

function masonryGridToolbox(){
    var macyInstance = Macy({
        // See below for all available options.
        container: '.toolbox--mix--filter',
        columns: 1,
        trueOrder: true,
        margin: 20,
        mobileFirst: true,
        breakAt: {
          768: {
            columns: 2
          },
          1280: {
            columns: 3
          }
        }
      });
}